import React from 'react';
import { TextWrapper, ComponentWrapper, Container } from 'components/common';
import { H3 } from 'components/common/Typography';
import { PrivacyWrapper } from './styles';

export const Privacy = () => (
  <ComponentWrapper large as={Container}>
    <PrivacyWrapper>
      <H3>Polityka prywatności</H3>

      <TextWrapper>
        Niniejsza polityka prywatności i plików cookies opisuje zasady postępowania z danymi osobowymi oraz
        wykorzystywania plików cookies i innych technologii w ramach strony internetowej https://outoffocus.video
        Administratorem strony jest OUT OF FOCUS SPÓŁKA Z OGRANICZONĄ ODPOWIEDZIALNOŚCIĄ z siedzibą pod adresem
        Sokolnicza 24 / 2, 05-825 Szczęsne, Polska, wpisana do Krajowego Rejestru Sądowego pod numerem KRS 0001149744,
        posługująca się numerem NIP 5291859036 oraz REGON 540671450. Kontakt z administratorem możliwy pod adresem
        e-mail hello@outoffocus.video.
        <br /> <br />
        §1 Definicje 1.Na potrzeby niniejszej polityki prywatności, przyjmuje się następujące znaczenie poniższych
        pojęć: <br />
        a) Administrator - OUT OF FOCUS SPÓŁKA Z OGRANICZONĄ ODPOWIEDZIALNOŚCIĄ z siedzibą pod adresem Sokolnicza 24 /
        2, 05-825 Szczęsne, Polska <br />
        b) Strona – strona internetowa dostępna pod adresem https://outoffocus.video <br />
        c) Użytkownik – każdy podmiot, który korzysta ze Strony. <br /> <br />
        §2 Dane osobowe <br />
        1. Użytkownik może przekazywać swoje dane osobowe Administratorowi za pomocą formularzy dostępnych na Stronie,
        takich jak formularz kontaktowy. <br />
        2. Administratorem danych osobowych Użytkownika jest Administrator. <br />
        3. Administrator gwarantuje poufność wszelkich przekazanych mu danych osobowych. <br />
        4. Podanie danych jest zawsze dobrowolne, ale niezbędne do podjęcia przez Użytkownika akcji, do której
        przeznaczony jest dany formularz. <br />
        5. Administrator nie udostępnia przekazanych mu danych jakimkolwiek podmiotom trzecim. <br />
        6. Dane osobowe są gromadzone z należytą starannością i odpowiednio chronione przed dostępem do nich przez osoby
        do tego nieupoważnione. <br />
        7. Użytkownikowi przysługują następujące uprawnienia: a) prawo do żądania dostępu do danych osobowych
        dotyczących osoby, której dane dotyczą, ich sprostowania, usunięcia lub ograniczenia przetwarzania, b) prawo do
        wniesienia sprzeciwu wobec przetwarzania, c) prawo do przenoszenia danych, d) prawo do cofnięcia zgody na
        przetwarzanie danych osobowych w określonym celu, jeżeli Użytkownik uprzednio taką zgodę wyraził, e) prawo do
        wniesienia skargi do organu nadzorczego w związku z przetwarzaniem danych osobowych przez Administratora <br />
        <br />
        §3 Pliki cookies <br />
        1. Administrator wykorzystuje pliki cookies (ciasteczka), czyli niewielkie informacje tekstowe, przechowywane na
        urządzeniu końcowym Użytkownika (np. komputerze, tablecie, smartfonie). Cookies mogą być odczytywane przez
        system teleinformatyczny Administratora.
        <br />
        2. Administrator przechowuje pliki cookies na urządzeniu końcowym Użytkownika, a następnie uzyskuje dostęp do
        informacji w nich zawartych w celach statystycznych, w celach marketingowych (remarketing, odzyskiwanie
        porzuconych koszyków) oraz w celu zapewnienia prawidłowego działania Strony.
        <br />
        3. Administrator informuje niniejszym Użytkownika, że istnieje możliwość takiej konfiguracji przeglądarki
        internetowej, która uniemożliwia przechowywanie plików cookies na urządzeniu końcowym Użytkownika. W takiej
        sytuacji, korzystanie ze Strony przez Użytkownika może być utrudnione.
        <br />
        4. Administrator wskazuje niniejszym, że pliki cookies mogą być przez Użytkownika usunięte po ich zapisaniu
        przez Administratora, poprzez odpowiednie funkcje przeglądarki internetowej, programy służące w tym celu lub
        skorzystanie z odpowiednich narzędzi dostępnych w ramach systemu operacyjnego, z którego korzysta Użytkownik.
        <br /> <br />
        §4 Logi serwera
        <br />
        1. Korzystanie ze Strony wiąże się z przesyłaniem zapytań do serwera, na którym przechowywana jest Strona.
        <br />
        2. Każde zapytanie skierowane do serwera zapisywane jest w logach serwera. Logi obejmują m.in. adres IP
        Użytkownika, datę i czas serwera, informacje o przeglądarce internetowej i systemie operacyjnym, z jakiego
        korzysta Użytkownik.
        <br />
        3. Logi zapisywane i przechowywane są na serwerze.
        <br />
        4. Dane zapisane w logach serwera nie są kojarzone z konkretnymi osobami korzystającymi ze Strony i nie są
        wykorzystywane przez Administratora w celu identyfikacji Użytkownika.
        <br />
        5. Logi serwera stanowią wyłącznie materiał pomocniczy służący do administrowania Stroną, a ich zawartość nie
        jest ujawniana nikomu poza osobami upoważnionymi do administrowania serwerem.
      </TextWrapper>
    </PrivacyWrapper>
  </ComponentWrapper>
);
